export function isYusafirDomain(): boolean {
    return typeof window !== 'undefined' && window.location.hostname.includes('yusafir');
  }